// Frontend-Spiegel der Backend-Capability-Liste (server/config/capabilities.js).
// Keys MÜSSEN identisch bleiben. Reihenfolge = Anzeigereihenfolge in der
// Benutzerverwaltung. Das `i18nKey` zeigt auf die Bereichsbezeichnung (Namespace nav).

export type Capability =
  | 'calendar'
  | 'appointments'
  | 'reminders'
  | 'recalls'
  | 'patients'
  | 'intake'
  | 'invoices'
  | 'invoices-manage'
  | 'reports'
  | 'event-log';

export interface CapabilityDef {
  key: Capability;
  /** i18n-Key der Bezeichnung (Namespace `nav`, bzw. `users.perm*` für Sonderfälle). */
  i18nKey: string;
  /** Optionaler i18n-Key für eine erläuternde Zeile unter dem Schalter. */
  hintKey?: string;
  /** Capability, die zusätzlich aktiv sein muss (z. B. "invoices-manage" setzt "invoices" voraus). */
  requires?: Capability;
}

export const CAPABILITIES: CapabilityDef[] = [
  { key: 'calendar', i18nKey: 'nav.calendar' },
  { key: 'appointments', i18nKey: 'nav.appointments' },
  { key: 'reminders', i18nKey: 'nav.reminders' },
  { key: 'recalls', i18nKey: 'nav.recalls' },
  { key: 'patients', i18nKey: 'nav.patients' },
  { key: 'intake', i18nKey: 'nav.intake' },
  { key: 'invoices', i18nKey: 'nav.invoices', hintKey: 'users.permInvoicesViewHint' },
  { key: 'invoices-manage', i18nKey: 'users.permInvoicesManage', hintKey: 'users.permInvoicesManageHint', requires: 'invoices' },
  { key: 'reports', i18nKey: 'nav.reports' },
  { key: 'event-log', i18nKey: 'nav.eventLog' },
];

export const CAPABILITY_KEYS: Capability[] = CAPABILITIES.map((c) => c.key);
